import type { PropsWithChildren } from 'react'

import {
  useSavedFilterManager,
  type UseSavedFilterManagerOptions,
} from '@webapp/hooks/useSavedFilterManager'
import {
  type SavedFilterCollection,
  type SavedFilterCollectionSchemas,
} from '@webapp/hooks/useSavedFilterManager/types'
import { SavedFilterManagerSaveButton } from './components/SavedFilterManagerSaveButton'
import { SavedFilterManagerSelect } from './components/SavedFilterManagerSelect'
import { SaveFilterManagerContext } from './SavedFilterManagerContext'
export interface ISavedFilterManagerProps<
  CollectionId extends SavedFilterCollection,
  Filters extends { [key: string]: any },
  CollectionSchema extends SavedFilterCollectionSchemas[CollectionId],
> extends UseSavedFilterManagerOptions<
  CollectionId,
  Filters,
  CollectionSchema
> {}

export const SavedFilterManager = <
  CollectionId extends SavedFilterCollection,
  Filters extends { [key: string]: any },
  CollectionSchema extends SavedFilterCollectionSchemas[CollectionId],
>({
  collectionId,
  filterManager,
  decodeFilters,
  encodeFilters,
  allowedFilters,
  additionalSavedValues,
  beforeApply,
  getScopeTags,
  children,
}: PropsWithChildren<
  ISavedFilterManagerProps<CollectionId, Filters, CollectionSchema>
>) => {
  const savedFilterManager = useSavedFilterManager({
    collectionId,
    filterManager,
    decodeFilters,
    encodeFilters,
    allowedFilters,
    additionalSavedValues,
    beforeApply,
    getScopeTags,
  })

  return (
    <SaveFilterManagerContext.Provider value={savedFilterManager}>
      {children}
    </SaveFilterManagerContext.Provider>
  )
}

SavedFilterManager.Select = SavedFilterManagerSelect
SavedFilterManager.SaveButton = SavedFilterManagerSaveButton
